import { render, staticRenderFns } from "./OtherService.vue?vue&type=template&id=12c2f106&scoped=true&"
import script from "./OtherService.vue?vue&type=script&lang=js&"
export * from "./OtherService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2f106",
  null
  
)

export default component.exports